import { IsString } from 'class-validator';

export class ForgotPasswordModel {
  @IsString()
  declare portalId: string;

  @IsString()
  declare email: string;
}
